import { Box } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { BoxForm, RadioGroup, RadioGroupOption, TextField } from 'components/Form'
import { CheckboxListFilterable } from 'components/Form/CheckboxListFilterable'
import { ChipsListFilterable } from 'components/Form/ChipsListFilterable'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { useApplicableDomainsOptions } from './hooks/useApplicableDomainsOptions'
import { useGetDomainsOptions } from './hooks/useGetDomainsOptions'
import { CommonSchema } from './schemas/commonSchema'

export const CommonForm = () => {
  const ability = useAbility()
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'prebid.protection.form',
  })
  const applicableDomainsOptions: RadioGroupOption[] = useApplicableDomainsOptions()
  const { control, watch } = useFormContext<CommonSchema>()
  const { domainsOptions } = useGetDomainsOptions()
  const { applicableDomains } = watch()

  const cannotCreate: boolean = ability.cannot('create', 'GlobalSetupFeature-protection')
  const cannotUpdate: boolean = ability.cannot('update', 'GlobalSetupFeature-protection')

  return (
    <Paper>
      <BoxForm>
        <TextField
          control={control}
          disabled={cannotCreate || cannotUpdate}
          label={t('name.label')}
          name='name'
        />

        <ChipsListFilterable
          control={control}
          disabled={cannotUpdate}
          label={t('blocked.label')}
          name='blocked'
          placeholder={t('blocked.placeholder')}
        />

        <Box>
          <RadioGroup
            control={control}
            disabled={cannotUpdate}
            label={t('applicableDomains.label')}
            name='applicableDomains'
            options={applicableDomainsOptions}
            row
          />

          {applicableDomains === 'specified' && (
            <CheckboxListFilterable
              control={control}
              disabled={cannotUpdate}
              name='domainIds'
              options={domainsOptions}
              placeholder={t('domainIds.placeholder')}
            />
          )}
        </Box>
      </BoxForm>
    </Paper>
  )
}
